module.exports = __webpack_public_path__ + "assets/Dashboard.af308f68.svg";